export default {
  nav_brand: 'AllChinaBuy Spreadsheet',
  nav_home: 'Startseite',
  nav_categories: 'Kategorien',
  nav_guides: 'Einkaufsführer',
  nav_faq: 'FAQ',
  lang_switch: 'Sprache',
  lang_en: 'English',
  lang_fr: 'Français',
  lang_de: 'Deutsch',
  lang_da: 'Dansk',

  hero_h1: 'AllChinaBuy Spreadsheet — Produkte, Verkäufer & Kaufberatung Finden',
  hero_subtitle: 'Entdecken Sie die neuesten AllChinaBuy-Ressourcen, beliebte Produkte, vertrauenswürdige Verkäuferinformationen, QC-Tipps, Versandguides und praktische Kaufberatung — alles an einem Ort.',
  hero_cta_primary: 'AllChinaBuy Spreadsheet Erkunden',
  hero_cta_secondary: 'Beliebte Funde Durchsuchen',
  hero_trust: 'Aktualisierte Ressourcen • Unabhängige Informationen • Einsteigerfreundliche Guides',
  hero_support_title: 'Suchen Sie ein AllChinaBuy Spreadsheet?',
  hero_support_desc: 'Finden Sie nützliche Produktlisten, Verkäuferressourcen, Kategorie-Guides, QC-Informationen, Versandtipps und AllChinaBuy-Kauftipps, ohne auf Dutzenden Websites suchen zu müssen.',

  whatis_title: 'Was ist AllChinaBuy Spreadsheet?',
  whatis_desc: 'Ein AllChinaBuy Spreadsheet ist eine kuratierte Sammlung von Produktlinks, Verkäuferinformationen, Kaufberatung und Qualitätskontrolltipps, die zusammengestellt wurden, um Käufern bei der Suche nach den besten Artikeln über die AllChinaBuy-Kaufagentenplattform zu helfen.',
  step_find: 'Finden',
  step_find_desc: 'Durchsuchen Sie kuratierte Produktlisten und Verkäuferverzeichnisse, organisiert nach Kategorie.',
  step_research: 'Recherchieren',
  step_research_desc: 'Vergleichen Sie Verkäufer, prüfen Sie QC-Fotos und überprüfen Sie Versandoptionen vor dem Kauf.',
  step_buy: 'Kaufen',
  step_buy_desc: 'Bestellen Sie zuversichtlich mit verifizierten Ressourcen und praktischen Kaufberatung.',

  categories_title: 'Beliebte Spreadsheet-Kategorien',
  categories_subtitle: 'Erkunden Sie organisierte Produktkategorien, um genau das zu finden, was Sie über AllChinaBuy brauchen.',
  cat_shoes: 'Schuhe',
  cat_hoodies: 'Hoodies / Pullover',
  cat_tshirts: 'T-Shirts',
  cat_jackets: 'Jacken',
  cat_pants: 'Hosen / Shorts',
  cat_headwear: 'Kopfbedeckungen',
  cat_sets: 'Sets',
  cat_underwear: 'Unterwäsche',
  cat_jersey: 'Trikots',
  cat_accessories: 'Accessoires',
  cat_bags: 'Taschen',
  cat_belts: 'Gürtel',
  cat_perfumes: 'Parfüms',
  cat_other: 'Sonstiges',
  cat_fashion: 'Fashion',
  cat_streetwear: 'Streetwear',
  cat_sportswear: 'Sportswear',
  cat_electronics: 'Elektronik',
  cat_home: 'Wohnen & Lifestyle',
  cat_popular: 'Beliebte Funde',

  featured_title: 'Empfohlene AllChinaBuy Spreadsheet-Ressourcen',
  featured_subtitle: 'Ein kuratiertes Überblick von Produkten, Verkäufern und Guides, um AllChinaBuy effizient zu nutzen.',
  col_product: 'Produkt',
  col_category: 'Kategorie',
  col_seller: 'Verkäufer',
  col_qc: 'QC',
  col_guide: 'Guide',
  col_action: 'Aktion',
  action_view: 'Details Ansehen',

  guides_title: 'Beliebte AllChinaBuy Guides',
  guide_spreadsheet: 'AllChinaBuy Spreadsheet Guide',
  guide_review: 'AllChinaBuy Bewertung',
  guide_shipping: 'AllChinaBuy Versandkosten',
  guide_coupon: 'AllChinaBuy Coupon',
  guide_discount: 'AllChinaBuy Rabattcode',
  guide_warehouse: 'AllChinaBuy Lager',
  guide_legit: 'Ist AllChinaBuy Legit?',
  guide_qc: 'AllChinaBuy QC Guide',
  guide_order: 'Wie Bestelle Ich bei AllChinaBuy',
  guide_buying: 'AllChinaBuy Kaufberatung',
  guide_read: 'Guide Lesen',

  why_title: 'Warum Diese Ressource Nutzen?',
  why_organized_title: 'Organisierte Ressourcen',
  why_organized_desc: 'Finden Sie nützliche AllChinaBuy-Informationen an einem Ort.',
  why_buying_title: 'Kaufberatung',
  why_buying_desc: 'Verstehen Sie Produkte, Verkäufer, QC, Versand und Bestellungen.',
  why_compare_title: 'Vergleichsrecherche',
  why_compare_desc: 'Vergleichen Sie AllChinaBuy mit anderen Kaufagenten-Plattformen.',
  why_safety_title: 'Sicherheitsinformationen',
  why_safety_desc: 'Lernen Sie, wie Sie Risiken erkennen und fundierte Entscheidungen treffen.',

  compare_title: 'AllChinaBuy vs Andere Kaufagenten',
  compare_subtitle: 'Vergleichen Sie wichtige Funktionen und Unterschiede zwischen AllChinaBuy und anderen beliebten Kaufagenten-Plattformen.',
  compare_feature: 'Funktion',
  compare_allchinabuy: 'AllChinaBuy',
  compare_superbuy: 'Superbuy',
  compare_cssbuy: 'CSSBuy',
  compare_sugargoo: 'Sugargoo',
  compare_pandabuy: 'PandaBuy',
  compare_check: 'Aktuelle Verfügbarkeit prüfen',

  safety_title: 'Intelligenter Einkaufen mit AllChinaBuy Sicherheits-Guides',
  safety_desc: 'Bevor Sie eine Bestellung aufgeben, lernen Sie wichtige Sicherheitspraktiken, die Ihr Geld, Ihre Daten und Ihr Einkaufserlebnis schützen.',
  safety_seller_title: 'Verkäufer-Recherche',
  safety_seller_desc: 'Lernen Sie, wie Sie Verkäufer vor dem Kauf verifizieren.',
  safety_qc_title: 'QC-Fotos',
  safety_qc_desc: 'Verstehen Sie, warum Qualitätskontrollfotos wichtig sind.',
  safety_link_title: 'Verdächtige Links',
  safety_link_desc: 'Erkennen Sie Warnsignale in Produktlistings und Verkäuferseiten.',
  safety_payment_title: 'Zahlungssicherheit',
  safety_payment_desc: 'Nutzen Sie sichere Zahlungsmethoden und verstehen Sie Käuferschutz.',
  safety_shipping_title: 'Versandrisiken',
  safety_shipping_desc: 'Navigieren Sie durch Zoll, Versicherung und Lieferüberlegungen.',
  safety_refund_title: 'Rückerstattungen',
  safety_refund_desc: 'Kennen Sie Ihre Rechte und Plattformrichtlinien vor dem Kauf.',

  faq_title: 'Häufig Gestellte Fragen',
  faq_q1: 'Was ist ein AllChinaBuy Spreadsheet?',
  faq_a1: 'Ein AllChinaBuy Spreadsheet ist eine kuratierte Sammlung von Produktlinks, Verkäuferreferenzen, Kaufberatung und Tipps, die organisiert sind, um Käufern bei der effizienten Nutzung der AllChinaBuy-Plattform zu helfen.',
  faq_q2: 'Ist AllChinaBuy ein legitimer Kaufagent?',
  faq_a2: 'AllChinaBuy ist eine Kaufagenten-Plattform, die internationale Käufer mit chinesischen Verkäufern verbindet. Wie alle Kaufagenten hängt die Legitimität von der aktuellen Servicequalität und den Nutzererfahrungen ab.',
  faq_q3: 'Wie verwende ich ein AllChinaBuy Spreadsheet?',
  faq_a3: 'Beginnen Sie mit dem Durchsuchen der Produktkategorien, die Ihren Wünschen entsprechen. Recherchieren Sie den Verkäufer, prüfen Sie verfügbare QC-Fotos, überprüfen Sie Versandkosten und folgen Sie unseren Schritt-für-Schritt-Kaufberatung.',
  faq_q4: 'Welche Versandoptionen bietet AllChinaBuy?',
  faq_a4: 'AllChinaBuy bietet in der Regel mehrere Versandlinien einschließlich EMS, DHL, FedEx und verschiedene Postdienste. Die Versandkosten variieren je nach Ziel, Gewicht und gewählter Methode.',
  faq_q5: 'Gibt es AllChinaBuy Coupons oder Rabattcodes?',
  faq_a5: 'Die Verfügbarkeit von Coupons ändert sich im Laufe der Zeit. Einige Plattformen bieten saisonale Aktionen, Empfehlungsrabatte oder Erstnutzer-Ersparnisse.',
  faq_q6: 'Wie prüfe ich QC-Fotos bei AllChinaBuy?',
  faq_a6: 'Qualitätskontrollfotos sind normalerweise in Ihrem Bestell-Dashboard verfügbar, nachdem Artikel im Lager angekommen sind. Fordern Sie detaillierte QC-Fotos vor dem Versand an.',
  faq_q7: 'Wie funktioniert der AllChinaBuy Lagerprozess?',
  faq_a7: 'Nach dem Kauf versenden Verkäufer Artikel an das AllChinaBuy-Lager. Artikel werden inspiziert, fotografiert (QC) und gelagert. Sie können dann Ihr Paket prüfen, konsolidieren und an Ihre Adresse versenden.',
  faq_q8: 'Wie vergleiche ich AllChinaBuy mit anderen Kaufagenten?',
  faq_a8: 'Vergleichen Sie basierend auf Versandraten, Servicegebühren, QC-Fotoqualität, Kundendienst-Reaktionszeit und Nutzerbewertungen. Unser Vergleichsbereich bietet einen strukturierten Ansatz zur Bewertung dieser Faktoren.',

  final_cta_title: 'Bereit, das AllChinaBuy Spreadsheet zu Erkunden?',
  final_cta_desc: 'Durchsuchen Sie organisierte Ressourcen, Produktberatung und nützliche Kaufinformationen an einem Ort.',
  final_cta_primary: 'AllChinaBuy Spreadsheet Erkunden',
  final_cta_secondary: 'Alle Kategorien Anzeigen',

  ext_btn_main: 'AllChinaBuy Spreadsheet',
  ext_btn_buy: 'Jetzt Kaufen',

  footer_disclaimer: 'Diese Website bietet unabhängige Informationsinhalte und garantiert keine Produktqualität, Verkäuferverhalten, Versandergebnisse, Rückerstattungen oder Plattformleistung. Nutzer sollten aktuelle Informationen vor dem Kauf verifizieren.',
  footer_about: 'Über Uns',
  footer_policy: 'Redaktionelle Richtlinien',
  footer_contact: 'Kontakt',
  footer_privacy: 'Datenschutz',
  footer_terms: 'Nutzungsbedingungen',
  footer_copyright: 'AllChinaBuy Spreadsheet. Unabhängige Informationsressource.',

  article_breadcrumb_home: 'Startseite',
  article_breadcrumb_article: 'Artikel',
  article_read_time: 'Min. Lesezeit',
  article_updated: 'Aktualisiert',
  article_related: 'Verwandte Ressourcen',
  article_back_home: 'Zurück zur Startseite',
  article_author: 'Forschungsteam',
  article_share: 'Diesen Guide Teilen',
  article_toc: 'Inhaltsverzeichnis',
  article_intro: 'Einleitung',
  article_conclusion: 'Fazit',
  article_cta_text: 'Erkunden Sie mehr AllChinaBuy-Ressourcen und finden Sie die besten Produkte für Ihre Bedürfnisse.',
  article_cta_button: 'Alle Ressourcen Durchsuchen',
};